<template>
  <div :class="[
  type === 'textarea' ? 'bee-textarea' : 'bee-input',
  size ? 'bee-input-' + size : '',
    {
    'bee-input-disabled': type !== 'textarea' && disabled,
    'bee-textarea-disabled': type === 'textarea' && disabled,
    'bee-input-group': $slots.prepend || $slots.append,
    'bee-input-append': $slots.append,
    'bee-input-prepend': $slots.prepend,
    'bee-input-prefix': $slots.prefix || prefixIcon,
    'bee-input-suffix': $slots.suffix || suffixIcon
    }]">
    <template v-if="type !== 'textarea'">
      <!-- 前置元素 -->
      <div class="bee-input-prepend-block" v-if="$slots.prepend">
        <slot name="prepend"></slot>
      </div>
      <input
        ref="input"
        :value="value"
        class="bee-input-inner"
        :type="type"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :autocomplete="autocomplete"
        @compositionstart="handleComposition"
        @compositionupdate="handleComposition"
        @compositionend="handleComposition"
        @input="handleInput"
        @focus="handleFocus"
        @blur="handleBlur"
        @change="handleChange"
      />
      <!-- 前置内容 -->
      <span class="bee-input-prefix-icon" v-if="$slots.prefix || prefixIcon">
        <slot name="prefix"></slot>
        <i class="bee-input-icon"
           v-if="prefixIcon"
           :class="prefixIcon">
        </i>
      </span>
      <span class="bee-input-suffix-icon" v-if="$slots.suffix || suffixIcon">
        <slot name="suffix"></slot>
        <i class="bee-input-icon"
           v-if="suffixIcon"
           :class="suffixIcon">
        </i>
      </span>
      <!-- 后置元素 -->
      <div class="bee-input-append-block" v-if="$slots.append">
        <slot name="append"></slot>
      </div>
    </template>
    <textarea
      ref="textarea"
      v-else
      :value="value"
      class="bee-textarea-inner"
      :placeholder="placeholder"
      :disabled="disabled"
      :readonly="readonly"
      :rows="rows"
      :autocomplete="autocomplete"
      @input="handleInput"
      @focus="handleFocus"
      @blur="handleBlur"
      @change="handleChange"
    >
    </textarea>
    <div class="bee-textarea-limit" v-if="type === 'textarea' && limit">
      {{isOver ? '已超出' : '还可以输入'}}<span class="bee-textarea-num" :class="{'bee-textarea-num-over': isOver}">{{num}}</span>个字
    </div>
  </div>
</template>

<script>
import {oneOf} from '../../utils/assist'

export default {
  name: 'BeeInput',
  props: {
    type: { // 输入框类型
      validator: (value) => {
        return oneOf(value, ['text', 'textarea', 'password', 'url', 'email', 'date'])
      },
      default: 'text'
    },
    value: [String, Number], // 输入框值
    size: String,
    placeholder: String, // 占位文本
    disabled: Boolean, // 禁用
    readonly: Boolean, // 只读
    prefixIcon: String, // 头部图标
    suffixIcon: String, // 尾部图标
    rows: { // textarea行数
      type: Number,
      default: 2
    },
    limit: Number,
    isCut: Boolean,
    autocomplete: { // 搜索建议
      validator: (value) => {
        return oneOf(value, ['on', 'off'])
      },
      default: 'off'
    }
  },
  data() {
    return {
      isOnComposition: false,
      isOver: false,
      num: this.limit
    }
  },
  computed: {

  },
  components: {

  },
  watch: {

  },
  methods: {
    getInput() {
      return this.$refs.input || this.$refs.textarea
    },
    inputSelect() {
      this.getInput().select()
    },
    handleComposition(event) {
      if(event.type === 'compositionstart') {
        this.isOnComposition = true
      }
      if(event.type === 'compositionend') {
        this.isOnComposition = false
        this.handleInput(event)
      }
    },
    handleInput(event) {
      if(this.isOnComposition) {
        return
      }
      if(event.target.value === this.value) {
        return
      }
      this.$emit('input', event.target.value)
      this.$nextTick(() => {
        let input = this.getInput()
        input.value = this.value
        if(this.type === 'textarea' && this.limit) {
          if(this.value.length < this.limit) {
            this.isOver = false
            this.num = this.limit - this.value.length
          } else {
            this.isOver = true
            this.num = this.value.length - this.limit
          }
        }
      })
    },
    handleFocus(event) {
      this.$emit('focus', event)
    },
    handleBlur(event) {
      this.$emit('blur', event)
    },
    handleChange(event) {
      this.$emit('change', event.target.value)
    }
  },
  created() {
    this.$on('inputSelect', this.inputSelect)
  },
  mounted() {

  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/input/input.vue